<ng-container *ngIf="data$ | async as data">
    <header class="header">
      <div class="header-info">
        <div [style.backgroundColor]="data.headerColor" class="header-info-top">
          <div class="header-info-headers">
            <h3 [ngStyle]="{fontSize:fontSize}">
              {{ data.firstName }} {{data.lastName}}</h3>
            <div class="dot">&middot;</div>
            <h3 [ngStyle]="{fontSize:fontSize}">
              {{ data.companyName }}</h3>
          </div>
        </div>
      </div>
      <div class="header-logo">
        <div class="header-logo-img">
          <div class="img-container"
            [ngStyle]="{'background-image': 'url(' + data.companyLogoUrl + ')'}">
          </div>
          <!-- <img 
            *ngIf="data.companyLogoUrl" 
            [src]="data.companyLogoUrl" 
            alt="Real Estate Partners"> -->
        </div>
      </div>
    </header>
    <h2 class="supportingDocText">Supporting Documents</h2>
    <h5  class="pre">PRE-APPROVAL LETTER</h5>
    <table class="offer-content-table">
      <thead>
        <tr>
          <td>
            <div class="header-space">&nbsp;</div>
          </td>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>
            <main >
              <!-- <div class="logo-container">
                <img src={{borrower.loanOfficer.companyLogoUrl}} alt="Best Offer Package Logo">
              </div> -->
              <section class="summary-section">
                <div class="letter-title">
                  <span>Conditional Loan Approval</span>
                </div>
                <div class="letter-content">
                  <div class="name">Dear Borrower,</div>
              
                  <div class="congratulations">
                    <p class="congratulations-section">
                      Congratulations! Thank you for choosing {{data.companyName}} to represent you in
                      securing your mortgage financing. We are confident we can provide
                      you with the most efficient home loan process available.
                    </p>
                  </div>
              
                  <div class="pre-approval">
                    <p class="pre-approval-title">Below is a summary of your pre-approval:</p>
                    <div class="pre-approval-info">
                      <div class="row">
                        <span class="title">Purchase Price:</span>
                        <span class="value">{{500000 | currency}}</span>     
                      </div>
                      <!-- <div class="row">
                        <span class="title">Max Purchase Price:</span>
                        <span class="value">{{ borrower.preApproval.purchasePrice=='' ? borrower.preApproval.maxPurchasePrice : borrower.preApproval.purchasePrice | currency }}</span>
                      </div>         -->
                      <div class="row">
                        <span class="title">Down Payment:</span>
                        <span class="value">{{ 10000 | currency }}</span>
                        <span class="value" *ngIf="false">{{ 10 }}%</span>
                      </div>
                      <div class="row">
                        <span class="title">Property Type:</span>
                        <span class="value">Single Family Residence</span>
                      </div>
                      <div class="row">
                        <span class="title">Occupancy:</span>
                        <span class="value">Second Home</span>
                      </div>
                      <div class="row">
                        <span class="title">FICO:</span>
                        <span class="value">123</span>
                      </div>
                      <div class="row">
                        <span class="title">Program:</span>
                        <span class="value">30 Year Fixed</span>
                      </div>
                    </div>
                  </div>
              
                  <div class="contacts">
                    Please do not hesitate to contact me directly at {{ data.phoneNumber }} with any questions
                    regarding this approval.
                  </div>
              
                  <div class="conclusion">
                    <p class="conclusion-section">
                      We look forward to servicing your future real estate financing needs and the needs of
                      your friends, family, and colleagues.
                    </p>
                  </div>
                  <div class="summary-signatures">
                    Thank you,
                   
                   <!-- <span class="image" *ngIf="data.signatureUrl as loanOfficerOfferSignature">
                      <img [src]="loanOfficerOfferSignature" alt="Loan officer offer signature">
                    </span> -->
                    <div class="img-container-data" *ngIf="data.signatureUrl as loanOfficerOfferSignature"
                      [ngStyle]="{'background-image': 'url(' + loanOfficerOfferSignature + ')'}">
                    </div>
                    <span class="lo-name">
                      {{ data.firstName }} {{data.lastName}}
                    </span>
                    <div class="company-name">{{data.title}}</div>
                  </div>
                  <div class="company-name">{{data.companyName}}</div>
                  <div class="company-name">NMLS ID : 123-456</div>
                  <div class="company-contacts">
                    <div>{{data.email}}</div>
                    <div>{{data.phoneNumber}}</div>
                  </div>
                </div>
              </section>
            </main>
          </td>
        </tr>
      </tbody>
    </table>
    <footer [style.backgroundColor]="data.footerColor" class="footer">
      <ul class="footer-info">
        <li>
            {{ data.firstName }} {{data.lastName}}, {{ data.phoneNumber }},
          <a href="mailto:{{ data.email }}">{{ data.email }}</a>
        </li>
        <li>{{ data.officeAddress }}</li>
        <li><a href="{{ data.website }}">{{ data.website }}</a></li>
      </ul>
    </footer>
  </ng-container>